<div *transloco="let t">
	<ng-container>
		<div class="px-12 flex flex-col">
			<div class="pt-6 pb-3 title">
				{{ t('userProfile.deleteUser') }}
			</div>
		</div>
		<div class="px-12 flex flex-row justify-end items-center">
			<div>
				<button (click)="confirmDeleteUser()" class="m-2" color="warn" mat-raised-button>
					<mat-icon>delete</mat-icon>
					<span>
						{{ t('commonActions.delete') }}
					</span>
				</button>
			</div>
		</div>
	</ng-container>
</div>
